// Angular
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';

// 3rdparty
import { Subject, Subscription, takeUntil, combineLatest, Observable, startWith, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
// Hostware

import { RequestResult } from '@app/core/dto/RequestResult';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { MaterialItem } from '@app/kip/dto/Material';
import { MaterialService } from '@app/kip/services/material-service';
import { vwTaskListItem } from '@app/kip/viewdto/vwCleaningState/vwTaskListItem';
import { VwTaskMatConsItem } from '@app/kip/viewdto/vwTaskMatConsItem';


import { Alert, HwAlertService, ToastPosition } from '@globalshared/hw-alert-component/src/lib';
import { TaskStates } from '@app/kip/enums/TaskStates';
import { AuthService } from '@app/core/services/auth.service';
import { vwTaskMatListItem } from '@app/kip/viewdto/vwTaskMatListItem';


@AutoUnsubscribe()
@Component({
  selector: 'material-consumption-dialog',
  templateUrl: './material-consumption-dialog.component.html',
  styleUrls: ['./material-consumption-dialog.component.scss']
})
export class MaterialConsumptionDialogComponent implements OnInit, OnDestroy {
  @ViewChild('MaterialsControl', { static: true }) materialList: MatSelect
  editorForm: FormGroup
  destroy$: Subject<boolean> = new Subject<boolean>(); addMaterials$: Subscription;
  tableColumns = ["CikNev", "Quantity", "Unit", "Action"]
  _data: vwTaskListItem;
  materials: MaterialItem[] = [];
  usedMaterials: vwTaskMatListItem[] = [];
  dataSource: MatTableDataSource<vwTaskMatListItem>

  filteredMaterials: Observable<MaterialItem[]>

  constructor(
    private fb: FormBuilder,
    private materialService: MaterialService,
    private sessionStorageService: SessionStorageService,
    private hwAlertService: HwAlertService,
    private translate: TranslateService,
    private authService: AuthService,
    private dialogRef: MatDialogRef<MaterialConsumptionDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: vwTaskListItem
  ) {
    this._data = data
    this.editorForm = fb.group({
      'Materials': new FormControl(""),
      'Quantity': new FormControl(0, Validators.min(0.01))
    })

  }

  //#region =============== Angular Lifecyle events ============================================================================
  ngOnInit(): void {
    const combinedSources = combineLatest({
      materials: this.materialService.loadAll(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId()),
      usedMaterials: this.materialService.loadTaskMaterials(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId(),
        this._data.Tasks[0].CleaningTypesId)
    }).pipe(takeUntil(this.destroy$)).subscribe(values => {
      this.materials = (values.materials as RequestResult).Data as MaterialItem[];
      // this.materialList.value = this.materials[0].UniqueId
      this.usedMaterials = (values.usedMaterials as RequestResult).Data as vwTaskMatListItem[];
      this.dataSource = new MatTableDataSource(this.usedMaterials)

      
            //   startWith(''),
      //   map( value => {
      //     return this.materials.filter(option => option.ItemName.toLowerCase().includes(value))
      // }))
    })


  }
  ngOnDestroy(): void {
    this.addMaterials$?.unsubscribe();
    this.destroy$.next(true);
    this.destroy$?.unsubscribe();
  }

  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================
  cancel() {
    this.dialogRef.close(undefined)
  }
  submit() {
    // mentés
    let materialsToAdd: VwTaskMatConsItem[] = []
    this.usedMaterials.forEach(item => {
      materialsToAdd.push({
        CikNum: item.UniqueId,
        CikSrc: item.Source,
        Quantity: item.Quantity
      })
    })
    this.materialService.addTaskMaterials(this.sessionStorageService.getSelectedUnit(), this.sessionStorageService.getSelectedHotelId(),
      this._data.Tasks[0].CleaningTypesId, materialsToAdd).subscribe(result => {
        const res = result as RequestResult;
        if (res.Code == 0) {
          this.hwAlertService.info(this.translate.instant("common.saved_successfully"), new Alert({ autoClose: true, fade: true, position: ToastPosition.TopRight }));
          this.dialogRef.close(true)
        } else {
          this.hwAlertService.error(this.translate.instant("common.error_while_performing_operation"), new Alert({ autoClose: false, fade: true, position: ToastPosition.TopRight }));
        }
      })
  }
  deleteRow(matItem: vwTaskMatListItem) {
    const index = this.usedMaterials.findIndex(item => item.UniqueId == matItem.UniqueId)
    if (index !== -1) {
      this.usedMaterials.splice(index,1)
      this.dataSource = new MatTableDataSource(this.usedMaterials);
    }
  }

  addItem() {
    const id = this.editorForm.controls["Materials"].value
    let matItem = this.materials.find(item => item.UniqueId == id)
    //  check to avoid duplication
    if (this.usedMaterials.find(item => item.UniqueId == id)) {
      this.usedMaterials.find(item => item.UniqueId == id).Quantity += this.editorForm.controls["Quantity"].value
    } else {
      let itemToAdd: vwTaskMatListItem = {
        Source: matItem.Source,
        Quantity: this.editorForm.controls["Quantity"].value,
        ItemNumber: matItem.ItemNumber,
        UniqueId: matItem.UniqueId,
        ItemName: matItem.ItemName,
        Unit: matItem.Unit
      }
      this.usedMaterials.push(itemToAdd)
    }
    this.dataSource = new MatTableDataSource(this.usedMaterials);
    // clear search input field
    // let emptyField: vwTaskMatListItem = {
    //     Source: -1,
    //     Quantity: 0,
    //     ItemNumber: "",
    //     UniqueId: 0,
    //     ItemName: '',
    //     Unit: ''
    // }
    // this.editorForm.controls["SearchField"].patchValue(emptyField)
    // this.editorForm.controls["Quantity"].patchValue(0)

  }
  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================




  MeEgyById() {
    const id = this.editorForm.controls["Materials"].value
    const found = this.materials.find(item => item.UniqueId == id);
    return found ? found.Unit : ""
  }
  materialListChange() {
    this.editorForm.controls["Quantity"].patchValue(0)
  }


  addButtonDisabled() {
      if( this.editorForm.controls["Materials"].value == '') {
      return true
    } else {
         if (this._data.Tasks[0].TaskState == TaskStates.Ended || this._data.Tasks[0].TaskState == TaskStates.Accepted) {
      if (this._data.Tasks[0].InspectorId !== this.authService.getUserIdFromToken()) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
    }
  }

  actionDisabled(): boolean {

    if (this._data.Tasks[0].TaskState == TaskStates.Ended || this._data.Tasks[0].TaskState == TaskStates.Accepted) {
      if (this._data.Tasks[0].InspectorId !== this.authService.getUserIdFromToken()) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }


  //#endregion =================================================================================================================
}

/*
ciksrc - source
uniqueid - ciknum

*/